var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgButtonRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-295 -90) translate(295 90)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 20.5,
  stroke: "#005AFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005AFF",
  fillRule: "nonzero",
  d: "M20.146 15.146c.174-.173.443-.192.638-.057l.07.057 5.405 5.405-5.405 5.405c-.196.196-.512.196-.708 0-.173-.173-.192-.443-.057-.637l.057-.07 4.697-4.698-4.697-4.697c-.173-.174-.192-.443-.057-.638l.057-.07z"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgButtonRight);
export default ForwardRef;